export default __webpack_public_path__ + "static/media/trolley.8a86d984.svg";